<div class="chips-header" *ngIf="showHeader">
  <div class="chips-header-content">
    <div class="chips-header-title">
      <span class="chips-viewing-label">{{ headerTitle }}</span>
    </div>
      <div class="org-chips-wrapper">
        <div class="org-chips-container">
          <div class="org-chips-list">
            @for (org of selectedOrgs; track org._id) {
              <div class="org-chip">
                <span class="org-name">{{ org.name }}</span>
                <img (click)="onRemove(org)" class="icon-close" ngbTooltip="Clear" placement="bottom" src="../../../../assets/Images/organisation-structure/Cross.svg" alt="remove" />
              </div>
            }
            @if (selectedOrgs && selectedOrgs.length > 1) {
              <button class="remove-all-btn" (click)="removeAll()" ngbTooltip="Clear All" placement="bottom" type="button">
                <fa-icon [icon]="faTimes"></fa-icon>
              </button>
            }
          </div>
        </div>
      </div>
    @if (!selectedOrgs || selectedOrgs.length === 0) {
    <div class="chips-header-description">
      <p>{{ headerDescription }}</p>
    </div>
    }
  </div>
</div>

